import { useEffect, useId, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useAuth } from '@context/AuthContext'
import useProcessDocuments from './useProcessDocuments'
import ProcessDocumentsView from './ProcessDocumentsView'
import './processDocuments.css'

export default function ProcessDocumentsModal({ isOpen, numeroProcesso = '', onClose }) {
  const { user, canManageLegalTemplates } = useAuth()
  const documents = useProcessDocuments(numeroProcesso, isOpen, user?.id, canManageLegalTemplates)
  const syncBusy = Boolean(documents.syncPhase)
  const syncBusyRef = useRef(syncBusy)
  syncBusyRef.current = syncBusy
  const [consultaId, setConsultaId] = useState('')
  const [page, setPage] = useState(0)
  const dialogRef = useRef(null)
  const closeRef = useRef(null)
  const titleId = useId()
  const descriptionId = useId()

  useEffect(() => {
    if (!isOpen) return undefined
    const previousFocus = document.activeElement
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    closeRef.current?.focus()
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
        if (!syncBusyRef.current) onClose()
      }
      if (event.key !== 'Tab') return
      const focusable = [...(dialogRef.current?.querySelectorAll('button:not([disabled]), a[href], select:not([disabled]), [tabindex="0"]') || [])]
        .filter((element) => element.getClientRects().length > 0)
      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      const outside = !dialogRef.current?.contains(document.activeElement)
      if (!first) {
        event.preventDefault()
        dialogRef.current?.focus()
      } else if (outside || event.shiftKey && document.activeElement === first || !event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        const destination = event.shiftKey ? last : first
        destination.focus()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = previousOverflow
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true })
    }
  }, [isOpen, onClose])

  useEffect(() => {
    setConsultaId('')
    setPage(0)
  }, [isOpen, numeroProcesso])

  if (!isOpen) return null
  return createPortal(<div className="modal-overlay" onMouseDown={(event) => { if (!syncBusy && event.target === event.currentTarget) onClose() }}>
    <div ref={dialogRef} className="modal-container modal-large process-documents-modal" role="dialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={descriptionId} tabIndex={-1}>
      <div className="modal-header">
        <div className="modal-title-area"><i className="fas fa-folder-open modal-icon" aria-hidden="true" /><div><h2 id={titleId} className="modal-title">Documentos do processo</h2><p id={descriptionId} className="modal-subtitle">{numeroProcesso}</p></div></div>
        <button type="button" ref={closeRef} className="modal-close" onClick={onClose} disabled={syncBusy} aria-label="Fechar documentos do processo"><i className="fas fa-times" aria-hidden="true" /></button>
      </div>
      <div className="modal-body"><ProcessDocumentsView numeroProcesso={numeroProcesso} documents={documents} consultaId={consultaId} canManageDocuments={canManageLegalTemplates}
        onConsultaChange={(id) => { setConsultaId(id); setPage(0); documents.closeText() }} page={page} onPageChange={setPage} /></div>
    </div>
  </div>, document.body)
}
